import React, { Component } from 'react'

class BrandTeaser extends Component {
    render() {
        return (
            <section className="brand_teaser">
                <div className="brand_teaser_inner reveal">
                    <img
                        src={process.env.PUBLIC_URL + "/image/shop_cover.png"}
                        className="brand_teaser_img"
                        alt="豆日子店面"
                    />
                    <div className="brand_teaser_content">
                        <p className="brand_teaser_label">Our Story</p>
                        <h2 className="brand_teaser_title">一甲子工藝，一碗豆花的堅持</h2>
                        <p className="brand_teaser_text">
                            從木柵街邊小店到國際級設計獲獎甜品店，豆日子傳承六十年豆花工藝，
                            堅持使用非基改有機黃豆，結合北歐極簡美學，帶給你每一天最純粹的甜蜜。
                        </p>
                        <a href="/about" className="brand_teaser_link">
                            了解更多 →
                        </a>
                    </div>
                </div>
            </section>
        );
    }
}

export default BrandTeaser;
